export function rowsFunction(initialState, vBenefit) {
  const {
    project_job_enquiry_cost_sheet_cost_detail = [],
    project_job_enquiry_cost_sheet_heading = [],
    project_job_enquiry_cost_sheet_profession_basic_information = [],
  } = initialState;
  return project_job_enquiry_cost_sheet_profession_basic_information?.map(
    (data) => {
      const firstSectionCols = [];
      const rowEndColumns = [];
      // if (projectDetails?.quotation_type?.name != "Cost Plus") {
      project_job_enquiry_cost_sheet_heading?.forEach((headingData) => {
        const columnName =
          headingData?.rate_category_item_name ||
          headingData?.rate_category_item?.name ||
          headingData?.heading_name;

        const cost = getColumnCost(
          project_job_enquiry_cost_sheet_cost_detail,
          data,
          headingData
        );
        let returnObj;
        if (columnName == "EDOC") {
          returnObj = returnObjFunction(headingData, columnName, cost, {
            inputType: "text",
          });
        } else if (columnName == "VBenefit (SAR)") {
          returnObj = returnObjFunction(headingData, columnName, cost, {
            disabled: vBenefit == "YES" ? true : false,
          });
        } else {
          returnObj = returnObjFunction(headingData, columnName, cost);
        }
        if (columnName == "VBenefit (SAR)" || columnName == "EDOC") {
          rowEndColumns.push(returnObj);
        } else {
          firstSectionCols.push(returnObj);
        }
      });
      return rowDataFunction(data, [...firstSectionCols, ...rowEndColumns]);
    }
  );
}

function getColumnCost(
  project_job_enquiry_cost_sheet_cost_detail,
  data,
  headingData
) {
  return project_job_enquiry_cost_sheet_cost_detail
    ?.filter(
      (costData) =>
        costData?.project_job_enquiry_cost_sheet_profession_basic_information_id ==
        data?.id
    )
    .find(
      (costData) =>
        costData?.project_job_enquiry_cost_sheet_heading_id == headingData?.id
    )?.cost;
}

function returnObjFunction(headingData, columnName, cost, options) {
  return {
    id: headingData?.id,
    rate_category_id: headingData?.rate_category_id || 1,
    rate_category_item_id: headingData?.id,
    rate_category_item_name: columnName,
    // type: headingData?.type,
    cost: cost,
    title: columnName,
    default: true,
    ...options,
  };
}

function rowDataFunction(data, firstSectionCols) {
  return {
    id: data?.id,
    job_position_id: data?.job_position_id,
    visa_profession_id: data?.visa_profession_id,
    profession_level_id: data?.profession_level_id,
    gender: data?.gender,
    nationality_id: data?.nationality_id,
    quantity: data?.quantity,
    sections: [
      {
        rate_category_id: 1,
        columns: firstSectionCols,
      },
    ],
  };
}

export function buttonFunction(
  setHeadingPopup,
  rowEdited,
  handleJobEnquiryEdit
) {
  return (
    <div className="w-full flex justify-end">
      <button
        type="button"
        className="p-2 max-w-[8rem] w-full bg-blue text-white text-sm rounded-md"
        onClick={() => {
          setHeadingPopup(true);
          if (rowEdited) handleJobEnquiryEdit(true);
        }}
      >
        Edit Heading
      </button>
    </div>
  );
}
